module.exports = __webpack_public_path__ + "static/Mee@2x.a74b489d.png";